import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-table-loading',
  template: `
    <div class="text-center p-3">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ message || 'Cargando...' }}</span>
      </div>
      <p *ngIf="message" class="mt-2">{{ message }}</p>
    </div>
  `
})
export class DataLoadingComponent {
  @Input() message?: string;
}
